import React, { useEffect, useState } from "react";
import "./toast.css";
import successIcon from "../../assets/circle-check.png";
import errorIcon from "../../assets/circle-alert.png";



export default function ToastContainer() {
  const [toast, setToast] = useState(null);

  useEffect(() => {
    let hideTimer = null;

    const onToast = (e) => {
      const payload = e.detail || {};

      // определяем иконку по типу
      let icon = payload.icon;
      if (!icon) {
        if (payload.type === "success") icon = successIcon;
        else if (payload.type === "error") icon = errorIcon;
      }

      const toastObj = {
        id: Date.now(),
        text: payload.text || "",
        title: payload.title || "",
        type: payload.type || "info",
        icon,
        duration: typeof payload.duration === "number" ? payload.duration : 3000,
      };

      setToast(toastObj);

      if (hideTimer) clearTimeout(hideTimer);
      hideTimer = setTimeout(() => setToast(null), toastObj.duration);
    };

    window.addEventListener("app:toast", onToast);
    return () => window.removeEventListener("app:toast", onToast);
  }, []);

  if (!toast) return null;

  return (
    <div className="toast-viewport" aria-live="polite">
      <div className={`toast-card toast-${toast.type}`} role="status">
        {toast.icon && (
          <div className="toast-icon">
            <img src={toast.icon} alt=""  width="18" height="18"/>
          </div>
        )}
        <div className="toast-body">
          {toast.title && <div className="toast-title">{toast.title}</div>}
          <div className="toast-text">{toast.text}</div>
        </div>
      </div>
    </div>
  );
}